import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.loading.default');
import { OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wiz-portal-season-loading-default',
    templateUrl: './view.html',
    styleUrls: ['./view.scss']
})
export class PortalSeasonLoadingDefaultComponent implements OnInit {
    constructor() { }

    public async ngOnInit() {
    }
}

export default PortalSeasonLoadingDefaultComponent;